// DO NOT set the `name` and `ticker` properties manually
// Instead use one of the get token metadata scripts https://github.com/ExodusMovement/exodus-core/tree/master/packages/assets-base#get-token-metadata

export default [
  {
    name: 'arb_ethereumarbone_aa4791c0',
    displayName: 'Arbitrum',
    decimals: 18,
    ticker: 'ARBethereumarboneAA4791C0',
    displayTicker: 'ARB',
    addresses: { current: '0x912CE59144191C1204E64559FE8253a0e49E6548' },
    info: {
      description: `ARB is the governance token for Arbitrum One, a blockchain that's built on top of Ethereum and aims to reduce fees and congestion. ARB holders can vote on Arbitrum DAO proposals.`,
      twitter: 'https://twitter.com/arbitrum',
    },
    primaryColor: '#12AAFF',
    gradientColors: ['#0D70CC', '#12AAFF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'magic_ethereumarbone_57601877',
    displayName: 'Magic',
    decimals: 18,
    ticker: 'MAGICethereumarbone57601877',
    displayTicker: 'MAGIC',
    addresses: { current: '0x539bdE0d7Dbd336b79148AA742883198BBF60342' },
    info: {
      description:
        'MAGIC is the utility token for the Treasure Metaverse, an NFT and gaming ecosystem. MAGIC can be earned by gaming and mining, plus participating in Bridgeworld.',
      twitter: 'https://twitter.com/Treasure_DAO',
    },
    primaryColor: '#E76767',
    gradientColors: ['#E03C3C', '#E76767'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'link_ethereumarbone_63f7deae',
    displayName: 'Chainlink',
    decimals: 18,
    ticker: 'LINKethereumarbone63F7DEAE',
    displayTicker: 'LINK',
    addresses: { current: '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4' },
    info: {
      description:
        'Blockchain-based smart contracts currently can’t connect to the outside world in a decentralized way. Using a network of decentralized data oracles, Chainlink aims to connect smart contracts to real-world data and payment systems.',
      reddit: 'https://www.reddit.com/r/Chainlink/',
      twitter: 'https://twitter.com/chainlink',
      website: 'https://chain.link/',
      telegram: 'https://t.me/chainlinkofficial',
    },
    primaryColor: '#3FA0F1',
    gradientColors: ['#3FA0F1', '#295ADA'],
    gradientCoords: { x1: '-22.982%', y1: '-43.915%', x2: '91.53%', y2: '101%' },
  },
  {
    name: 'gmx_ethereumarbone_34725f35',
    displayName: 'GMX',
    decimals: 18,
    ticker: 'GMXethereumarbone34725F35',
    displayTicker: 'GMX',
    addresses: { current: '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a' },
    info: {
      description:
        'GMX is the utility and governance token for the GMX exchange, an easy-to-use spot and perpetual exchange with low fees and reduced liquidation risk.',
      twitter: 'https://twitter.com/GMX_IO',
      website: 'https://gmx.io/',
      telegram: 'https://t.me/GMX_IO',
    },
    primaryColor: '#60CFC8',
    gradientColors: ['#60CFC8', '#4312E8'],
    gradientCoords: { x1: '11.118%', y1: '26.577%', x2: '24.212%', y2: '18.305%' },
  },
  {
    name: 'weth_ethereumarbone_c53d6bd0',
    displayName: 'Wrapped Ether',
    decimals: 18,
    ticker: 'WETHethereumarboneC53D6BD0',
    displayTicker: 'WETH',
    addresses: { current: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1' },
    info: {
      description:
        'WETH is the wrapped version of ETH that refers to the ERC-20 compatible version of Ether. Wrapping ETH does not affect its value, 1 ETH is always 1 WETH.',
      website: 'https://weth.io/',
    },
    primaryColor: '#FF58A2',
    gradientColors: ['#EC9CC6', '#ED1E79'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '20%', y2: '20%' },
  },
  {
    name: 'usdc_ethereumarbone_2e1129c4',
    displayName: 'USDC',
    decimals: 6,
    ticker: 'USDCethereumarbone2E1129C4',
    displayTicker: 'USDC',
    addresses: { current: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831' },
    info: {
      description:
        'USDC is a token designed as a stablecoin issued by Circle and Coinbase. Each unit of USDC is backed by a unit of US Dollar in audited bank accounts in order to ensure 1 USDC is always equal to 1 USD.',
      reddit: 'https://www.reddit.com/r/USDC/',
      twitter: 'https://twitter.com/centre_io',
      website: 'https://www.centre.io/usdc',
    },
    primaryColor: '#3E90E8',
    gradientColors: ['#3E90E8', '#2775CA'],
    gradientCoords: { x1: '102%', y1: '101%', x2: '0%', y2: '0%' },
  },
  {
    name: 'usdt_ethereumarbone_efa95268',
    displayName: 'Tether USD',
    decimals: 6,
    ticker: 'USDTethereumarboneEFA95268',
    displayTicker: 'USDT',
    addresses: { current: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9' },
    info: {
      description:
        'Tether is a multi-chain stablecoin. Each USDT token is designed to be backed by a U.S. Dollar held in banking reserves.',
      reddit: 'https://www.reddit.com/r/Tether/',
      twitter: 'https://twitter.com/tether_to',
      website: 'https://tether.to/',
    },
    primaryColor: '#53AE94',
    gradientColors: ['#53AE94', '#2E9175'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'rdnt_ethereumarbone_58d922a3',
    displayName: 'Radiant Capital',
    displayTicker: 'RDNT',
    ticker: 'RDNTethereumarbone58D922A3',
    decimals: 18,
    addresses: { current: '0x3082cc23568ea640225c2467653db90e9250aaa0' },
    info: {
      description:
        'RDNT is the native utility token for Radiant Capital, a non-custodial DeFi platform where users can deposit and borrow assets across multiple blockchains.',
      website: 'https://radiant.capital',
      twitter: 'https://twitter.com/RDNTCapital',
      telegram: 'https://t.me/radiantcapitalofficial',
    },
    primaryColor: '#7159FF',
    gradientColors: ['#472FCF', '#7159FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
]
